import { createFileRoute } from '@tanstack/react-router';

import { HackathonsView } from '@/features/Hackathons/HackathonsView';

export const Route = createFileRoute('/trainer/batches/$batchId/hackathons/')({
  component: HackathonsTab,
});

export function HackathonsTab() {
  const { batchId } = Route.useParams();
  return (
    <HackathonsView
      batchId={batchId}
      detailTo="/trainer/batches/$batchId/hackathons/$hackathonId"
    />
  );
}
